import React, { FunctionComponent } from 'react'
import styles from './PresenterCard.module.scss'
import { PresenterCardProps } from './types'
import classNames from 'classnames'
import Icon from '@bt-react/components/Icon'

const PresenterCard: FunctionComponent<PresenterCardProps> = props => <div
  data-bdd={props.dataBdd}
  className={classNames(
  styles['presenter-card'], {
    [styles['presenter-card--highlighted']]: props.presenterSpotlighted
  })}
  onClick={props.onClick}
  hidden={props.hidden}
>
  <Icon name={props.iconName} />
  <p className={styles['presenter-card__presenter-name']}>{props.firstName} {props.lastName}</p>
</div>

export default PresenterCard